$(document).ready(function() {

  $(document).on('init:modal', function (e, data) {
      $receiver = $('#modal-receiver');

      $receiver.find('.modal-content').html(data);

      $receiverContainer = $receiver.find('.modal-container');
      $receiverModal = $receiver.find('.modal');

      if($receiverContainer.data('id')){
          $receiverModal.attr('id', $receiverContainer.data('id'));
      }

      // INIT FORM INPUTS
      $('.form-group.radio_buttons').trigger('radio-group:init');
      $('.o-annuaire-hidden').each(function(e) {
        $(this).hide();
      })

      $('.show-contact').on('click', function(e) {
        e.preventDefault();
        $(this).hide();
        $('.o-annuaire-hidden').show();
      })

      $receiverModal.show();

      $('.modal-container').each(function() {
        block = $(this),
        societyDetails = block.find('.modal-container__societyDetails'),
        closeButton = societyDetails.find('.o-close');

        closeButton.on('click', function(e) {
          e.preventDefault();
         $('.modal-container').toggleClass('close');
        });
      });

      $('.modal-container').each(function() {
        block = $(this),
        addFonds = block.find('.modal-container__addFonds'),
        closeButton = addFonds.find('.o-close'),
        page = $('body').not('.modal-container__addFonds');

        // page.on('click', function(e) {
        //   e.preventDefault();
        //  $('.modal-container').toggleClass('close');
        // });

        closeButton.on('click', function(e) {
          e.preventDefault();
         $('.modal-container').toggleClass('close');
        });
      });

      $('.modal-container').each(function() {
        block = $(this),
        unauthorizedContent = block.find('.modal-container__unauthorizedContent'),
        closeButton = unauthorizedContent.find('.o-close');

        closeButton.on('click', function(e) {
          e.preventDefault();
         $('.modal-container').toggleClass('close');
        });
      });

      $('.modal-container').each(function() {
        block = $(this),
        deleteWalletContent = block.find('.modal-container__deleteWallet'),
        closeButton = deleteWalletContent.find('.o-js-close');

        closeButton.on('click', function(e) {
          e.preventDefault();
         $('.modal-container').toggleClass('close');
        });
      });

      $('.modal-container').each(function() {
        block = $(this),
        exportContent = block.find('.modal-container__export'),
        closeButton = exportContent.find('.o-js-close');

        closeButton.on('click', function(e) {
          e.preventDefault();
         $('.modal-container').toggleClass('close');
        });
      });

      $('.modal-container').each(function() {
        block = $(this),
        exportContent = block.find('.modal-container__willDeleteWallet'),
        closeButton = exportContent.find('.o-js-close');

        closeButton.on('click', function(e) {
          e.preventDefault();
         $('.modal-container').toggleClass('close');
        });
      });
  });
});
